import { render, staticRenderFns } from "./ProjectsListPage.vue?vue&type=template&id=234d837e&scoped=true&"
import script from "./ProjectsListPage.vue?vue&type=script&lang=js&"
export * from "./ProjectsListPage.vue?vue&type=script&lang=js&"
import style0 from "./ProjectsListPage.vue?vue&type=style&index=0&id=234d837e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "234d837e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('234d837e')) {
      api.createRecord('234d837e', component.options)
    } else {
      api.reload('234d837e', component.options)
    }
    module.hot.accept("./ProjectsListPage.vue?vue&type=template&id=234d837e&scoped=true&", function () {
      api.rerender('234d837e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/projects/ProjectsListPage.vue"
export default component.exports